export const glCodes = {
	'RoU Asset - Initial Recognition': 'rouAssetInitialRecognition',
	'RoU Asset - Modification': 'rouAssetModification',
	'RoU Asset - Pre-payment': 'rouAssetPrepayments',
	'RoU Asset - Upfront Payment': 'rouAssetUpfrontPayment',
	'RoU Asset - Indirect Costs': 'rouAssetIndirectCosts',
	'RoU Asset - Cash Incentive': 'rouCashIncentive',
	'RoU Asset - Knock Off': 'rouAssetKnockOff',
	'Security Deposit': 'securityDepositName',
	'Lease Liability - Initial Recognition': 'leaseLiabilityInitialRecognition',
	'Lease Liability - Modification': 'leaseLiabilityModification',
	'Lease Liability - Payment': 'leaseLiabilityPayment',
	'Lease Liability - Interest': 'leaseLiabilityInterest',
	'Interest Expense': 'interestExpense',
	'Depreciation - RoU': 'depreciationRou',
	'Accum Depreciation - RoU': 'accumDepreciationRouDepreciation',
	'Accum Depreciation - RoU - Knock Off': 'accumDepreciationRouKnockOff',
	'A/P Control Ledger - Pre-payment': 'apControlLedgerPrepayments',
	'A/P Control Ledger - Upfront Payment': 'apControlLedgerUpfrontPayment',
	'A/P Control Ledger - Indirect Costs': 'apControlLedgerIndirectCosts',
	'A/P Control Ledger - Security Deposit': 'apControlLedgerSecurityDeposit',
	'A/P Control Ledger - Payment': 'apControlLedgerPayment',
	'A/R Control Ledger - Cash Incentive': 'arCashIncentive',
};
